var map = {
	"./112-benjamin_franklin_quotes.jpeg": "068b",
	"./1285-william-arthur-ward-quotes.jpeg": "5e0d",
	"./1373-gore-vidal-quotes.jpeg": "3d49",
	"./218-nietzsche_friedrich_quotes.jpeg": "0ecf",
	"./24-henry-ward-beecher-quotes.jpeg": "c86f",
	"./265-william_shakespeare_quotes.jpeg": "c785",
	"./340-goethe_johann_wolfgang_von_quotes.jpeg": "a38d",
	"./440-african_proverbs_quotes.jpeg": "8aeb",
	"./4674-gelett-burgess-quotes.jpeg": "b9de",
	"./85-charles_dickens_quotes.jpeg": "92c4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "627d";